import React, { useState } from "react";
import HeroSlider from "../layout/HeroSlider";

const Banner = () => {
  return (
    <>
      <div className="bg-white">
        <div className="mx-auto py-5 max-w-screen-2xl px-3 sm:px-10">
          <div className="flex w-full">
            <div className=" flex-shrink-0 xl:px-1 lg:block w-full lg:w-full">
              <HeroSlider />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Banner;
